import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const TrashOutlined = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.SEMANTIC.ERROR
}: IconProps) => {
  return (
    <svg
      viewBox='0 0 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <g
        id='SVGRepo_iconCarrier'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'>
        <path d='M28.4375 8.021L27.5338 22.6409C27.3028 26.3762 27.1874 28.2439 26.2512 29.5867C25.7881 30.2505 25.1923 30.8108 24.501 31.2318C23.1031 32.0835 21.2319 32.0835 17.4894 32.0835C13.742 32.0835 11.8684 32.0835 10.4694 31.2302C9.77783 30.8085 9.18167 30.2472 8.71891 29.5822C7.78295 28.2373 7.67003 26.367 7.44422 22.6265L6.5625 8.021' />
        <path d='M4.375 8.02067H30.625M23.4146 8.02067L22.4191 5.96694C21.7578 4.60272 21.427 3.9206 20.8566 3.49519C20.7302 3.40082 20.5962 3.31687 20.456 3.24419C19.8244 2.9165 19.0664 2.9165 17.5503 2.9165C15.9962 2.9165 15.2192 2.9165 14.577 3.25793C14.4347 3.3336 14.2989 3.42094 14.171 3.51904C13.5941 3.96169 13.2718 4.66876 12.6271 6.08292L11.7438 8.02067' />
        <path d='M13.8535 24.0625V15.3125' />
        <path d='M21.1465 24.0625V15.3125' />
      </g>
    </svg>
  );
};

export default TrashOutlined;
